// extracted by mini-css-extract-plugin
export default {"header":"Header_header__vvWyG","title":"Header_title__dw2ox font-xs-bold","details":"Header_details__FLU1d"};